import { CustomOptionsServiceBase } from '@/services/CustomOptionsServiceBase';

export class MtbCustomOptionsService extends CustomOptionsServiceBase {
  _createCustomParser() {
    return this._createDefaultParser()
      .extendConfig()
      .addBooleanParser('mtb_show_additional_info', {
        defaultValue: true,
      })
      .addArrayParser('mtb_excluded_banks', {
        defaultValue: [],
      })
      .addBooleanParser('mtb_desktop_qr_hpp_redirect', {
        defaultValue: false,
      });
  }

  getOptions(options = {}) {
    return this._createCustomParser().parse(options);
  }
}
